import {Component, OnInit, Inject, Injectable} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActiveService } from '../../../view/services/active.service';
import { PanoramicService } from '../../../view/services/panoramic.service';
import { FormService } from "../../services/forms/form.service";
import { FilterService } from "../../services/filter/filter.service";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: 'app-modal-remove',
  templateUrl: './modal-remove.component.html',
  styleUrls: ['./modal-remove.component.css']
})
export class ModalRemoveComponent implements OnInit {

  id: any;
  name: any;
  lat: any;
  lng: any;
  hash: any;
  CAMPOS_ACTIVO: CamposActivo[] = [];
  dataSource = new MatTableDataSource<CamposActivo>([]);
  loading = true;
  displayedColumns: string[] = [];

  constructor(protected panoramicService: PanoramicService, protected activeService: ActiveService, protected formService: FormService, protected filterService: FilterService,
              private dialogRef: MatDialogRef<ModalRemoveComponent>, @Inject(MAT_DIALOG_DATA) public  data: any) {
    this.id = data.id;
    this.lat = data.lat;
    this.lng = data.lng;
    this.name = data.name;
    this.hash = data.hash;
    
  }

  ngOnInit() {
    this.getCampos();
  }

getCampos(){
  var formCapId;
  var camposActivo;
  this.activeService.getActive(this.id).subscribe((data: {}) => {
    formCapId = data["formulario_captura_id"]
    this.filterService.getCamposResultado(formCapId).subscribe((data2: {}) => {
    camposActivo = data2;
    camposActivo.forEach(element => {
      const campoN = {
        nombre: element["formulario_campo_nombre"],
        valor: element["formulario_captura_campo_valor"],
        id: element["formulario_captura_campo_id"]
      };
      this.CAMPOS_ACTIVO.push(campoN);
    });
    this.CAMPOS_ACTIVO.sort(function (a, b) {
      if (a.id > b.id) {
        return 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    const latitud = {
      nombre: "Latitud",
      valor: Number(this.lat),
      //valor: this.convertToDMS(this.lat) + (this.lat  >= 0 ? "N" : "S"),
      //Habilitar cuando se implemente en la herramienta de filtro
      id: 0
    };
    const longitud = {
      nombre: "Longitud",
      valor: Number(this.lng),
      //valor: this.convertToDMS(this.lng) + (this.lng >= 0 ? "E" : "W"), 
      //Habilitar cuando se implemente en la herramienta de filtro
      id: 0
    };
    this.CAMPOS_ACTIVO.push(latitud);
    this.CAMPOS_ACTIVO.push(longitud);
    this.generateTable();
  });
  });
}

generateTable(){
  this.displayedColumns = ["nombre", "valor"];
  this.loading = false;
  this.dataSource.data = this.CAMPOS_ACTIVO;
}

convertToDMS(coordinate){
  var absolute = Math.abs(coordinate);
  var degrees = Math.floor(absolute);
  var minutesNotTruncated = (absolute - degrees) * 60;
  var minutes = Math.floor(minutesNotTruncated);
  var seconds = ((minutesNotTruncated - minutes) * 60);
  return degrees + "°" + minutes + "'" + seconds.toFixed(2) + '"';
}

  public  updateActive() {
      var activeDetails = {
        formulario_captura_nombre: this.name,
      };
      this.activeService.updateActive(this.id, activeDetails).subscribe((data: {}) => {
        this.dialogRef.close({ data: data });
      });
  }

  public deleteActive() {
    this.activeService.deleteActive(this.id).subscribe((data: {}) => {
      this.panoramicService.deleteHotspot(this.id);
      this.dialogRef.close();
    });
  }

}

export interface CamposActivo {
  nombre: string;
  valor: number;
  id: number;
}